import React from 'react';
import { CategoryProvider, NavigationProvider, OrderManagementProvider, ConfigProvider } from './context';
import { RouteSwitcher } from './pages';

interface AppProps {
    sessionExpired(reason: string): JSX.Element;
}

const App = ({ sessionExpired }: AppProps) => (
    <>
        <OrderManagementProvider>
            <ConfigProvider>
                <CategoryProvider>
                    <NavigationProvider>
                        <RouteSwitcher sessionExpired={sessionExpired} />
                    </NavigationProvider>
                </CategoryProvider>
            </ConfigProvider>
        </OrderManagementProvider>
    </>
);

export default App;
